// extracted by mini-css-extract-plugin
export default {"calendarLink":"AddToCalendar_calendarLink__EoA7X"};